import Scripts from "next/script";

const Script = () => {
    return (
        <Scripts
            strategy="afterInteractive"
            id="CookieConsent"
            src="https://policy.app.cookieinformation.com/uc.js"
            data-culture="EN"
            data-gcm-version="2.0"
            type="text/javascript"
        />
    );
};
export default Script;
